import { render, staticRenderFns } from "./designInterface.vue?vue&type=template&id=a57edcbe&"
import script from "./designInterface.vue?vue&type=script&lang=js&"
export * from "./designInterface.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports